import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography, Divider, } from '@mui/material';
import { isEmpty, xor } from 'lodash-es';
import CustomButton from '../../common/CustomButton';
import MultipleChoiceAnswer from './MultipleChoiceAnswer';
import SingleChoiceAnswer from './SingleChoiceAnswer';
import FillInTheBlank from './FillInTheBlank';
import OpenEnded from './OpenEnded';
import AnswerResult from './AnswerResult';
const Quiz = ({ question, nextQuestion, setCourseResult, isKnowledgeCheck, blockInput, showAnswer, }) => {
    // console.log(question);
    // const [answerSubmitted, setAnswerSubmitted] = useState<boolean>(false);
    const [userAnswers, setUserAnswers] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const checkAnswerCorrect = () => {
        if (question.type === 'fillInTheBlank') {
            // for (const item of answerValueId) {
            //   if (userAnswers[userAnswers.length - 1] === item) {
            //     return true; // Return false if there is a match
            //   }
            // }
            // return false; // Return true after checking all items
            const userAnswer = userAnswers[0];
            return !!question.answers.find((answer) => (answer.id === userAnswer));
        }
        if (question.type === 'openEnded') {
            return !!inputValue; // Return true for any answer
        }
        return isEmpty(xor(question.correctAnswer, userAnswers));
    };
    const setCourseResultFn = () => {
        setCourseResult({
            isCorrect: checkAnswerCorrect(),
            question,
            userAnswers,
            inputValue,
        });
    };
    const resetQuestion = () => {
        setUserAnswers([]);
    };
    return (_jsxs(Box, { children: [_jsx(Typography, { component: "div", variant: "h3", sx: {
                    my: 1,
                    whiteSpace: 'pre-line',
                }, children: question.questionText }), _jsx(Divider, {}), question.type === 'multipleResponseQuestion'
                && (_jsx(MultipleChoiceAnswer, { answers: question.answers, correctAnswer: question.correctAnswer, setAnswer: setUserAnswers, userAnswers: userAnswers, isSubmit: showAnswer }, question.id)), question.type === 'multipleChoiceQuestion' && (_jsx(SingleChoiceAnswer, { answers: question.answers, correctAnswer: question.correctAnswer, setAnswer: setUserAnswers, userAnswers: userAnswers, isSubmit: showAnswer }, question.id)), question.type === 'fillInTheBlank' && (_jsx(FillInTheBlank, { answers: question.answers, correctAnswer: question.correctAnswer, setAnswer: setUserAnswers, userAnswers: userAnswers, isSubmit: showAnswer, setInputValue: setInputValue, inputValue: inputValue }, question.id)), question.type === 'openEnded' && (_jsx(OpenEnded, { isSubmit: showAnswer, setInputValue: setInputValue, inputValue: inputValue }, question.id)), _jsx(Box, { children: showAnswer && (question.type !== 'openEnded') && (_jsx(AnswerResult, { answerCorrect: checkAnswerCorrect() })) }), _jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "center", children: [!showAnswer && (_jsx(CustomButton, { label: "Submit", disabled: ((question.type === 'openEnded' && !inputValue) || (question.type !== 'openEnded' && !userAnswers.length)) || blockInput, onClick: () => {
                            setCourseResultFn();
                            // if (isKnowledgeCheck) {
                            //   nextQuestion();
                            // }
                        }, customStyle: { flexGrow: 0, minWidth: 100 } })), showAnswer && !isKnowledgeCheck && (_jsx(CustomButton, { label: "Next", disabled: blockInput, onClick: () => {
                            resetQuestion();
                            nextQuestion();
                            setInputValue('');
                        }, customStyle: { flexGrow: 0, minWidth: 100 } }))] })] }));
};
export default observer(Quiz);
//# sourceMappingURL=Quiz.js.map